import {GET_LOGIN_REQUESTED, GET_LOGIN_SUCCESS, GET_LOGIN_FAILED} from "resources/actionTypes";

const initialState = {
  userLogin: [],
  loading: false,
  error: null,
};

export default function userLogin(state = initialState, action) {
  switch (action.type) {
    case GET_LOGIN_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        userLogin: action.userLogin,
      };
    case GET_LOGIN_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
